import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: 'dialog-header',
  templateUrl: './dialog-header.component.html',
  styleUrls: ['./dialog-header.component.scss']
})
export class DialogHeaderComponent {
  @Input() headerKey: string;
  @Input() headerParam: string | undefined = undefined;
  @Input() handleOnClose = false;
  @Input() dialogRef: MatDialogRef<any>;
  @Output() onClose = new EventEmitter<boolean>;
}
